<template>
  <section class="mt-3 mb-3">
    <b-card title="Supprimer des mappings">
      <b-card-body>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>
          <b-table
            show-empty
            empty-text="Il n'y a pas de mappings"
            striped
            hover
            :items="mapping"
            :fields="fields"
            v-if="mapping !== []"
          >
            <template #cell(actions)="{item ,index}">
              <div class="float-right">
                <b-button
                  size="sm"
                  @click="deleteMapping(item.id, index)"
                  class="mr-1"
                  variant="danger"
                >
                  Supprimer
                </b-button>
              </div>
            </template>
            <template #empty="scope">
              <p class="text-center">{{ scope.emptyText }}</p>
            </template>
          </b-table>
          <p v-else>
            Cette catégorie Mirakl n'est mappée à aucune catégorie Greenweez
          </p>
        </b-skeleton-wrapper>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SupprimeMapping",
  props: {
    mapping: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(["isLoading"]),
    isMapping() {
      return this.mapping ? this.mapping.length === 0 : false;
    }
  },
  data() {
    return {
      fields: [
        {
          key: "legacyCategoryName",
          label: "Nom catégorie Greenweez",
          colspan: 1
        },
        {
          key: "miraklAttributeCode",
          label: "Attribut",
          colspan: 1
        },
        {
          key: "miraklValueCode",
          label: "Valeur",
          colspan: 1
        },
        {
          key: "actions",
          label: "Actions",
          thClass: "text-right pr-4",
          colspan: 1
        }
      ]
    };
  },
  methods: {
    deleteMapping(item, idx) {
      this.mapping.splice(idx, 1);
      this.$store.dispatch("mapping/deleteCategoryMapping", item);
    }
  }
};
</script>

<style scoped></style>
